import styled from 'styled-components';

export const SubNav = styled.div`
  display: grid;
  grid-area: subNav;
  grid-template-areas:
    'subheader'
    'submenu'
    '.';
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 230px;
  background-color: ${({ theme }) => theme.vars.newColor.lightGS2};
  color: ${({ theme }) => theme.vars.newColor.darkGS1};
  width: 230px;
  height: 100vh;
  overflow: hidden;
`;

export const SubNavHeader = styled.div`
  grid-area: subheader;
  font-size: 18px;
  padding-top: 22px;
  padding-left: 20px;
  margin-bottom: 15px;
  font-weight: bold;
  height: 46px;
`;

export const SubNavMenu = styled.div`
  grid-area: submenu;
  margin: 0px 2rem;

  > * {
    margin-bottom: 5px;
  }

  a {
    display: block;
    text-decoration: none;

    &:focus,
    &:hover,
    &:visited,
    &:link,
    &:active {
      text-decoration: none;
    }
  }
`;
